import { API } from '../utils/constants'

const services = {
  list: API + '/contacts',
  delete: API + '/contacts',
  detail: API + '/contacts',
  register: API + '/contacts',
}

export async function getAllContacts(params?: any) {
  const _token = localStorage.getItem('__token')

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(
    params
      ? `${services.list}?start_date=${params.start ?? ''}&end_date=${params.end ?? ''}&status=${params.status ?? ''}`
      : services.list,
    requestOptions,
  ).then((response) => {
    res = response.json()
  })

  return res
}

export async function newContact(body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(services.register, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function archiveContact(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.register}/${id}/archive`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function deleteContact(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.delete}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function getById(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.detail}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function updateById(id: any, body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.detail}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}
